import { createCustomElement } from "@angular/elements";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

declare global {
  const FEATURE_APP_BASE_URL: string | undefined;
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    // Dual-boot: register as a Custom Element when running inside a Feature Hub
    if (typeof FEATURE_APP_BASE_URL !== "undefined" && !!FEATURE_APP_BASE_URL) {
      if (!customElements.get("app-vbo-root")) {
        const customElement = createCustomElement(AppComponent, {
          injector: appRef.injector
        });
        customElements.define("app-vbo-root", customElement);
      }
    }
  })
  .catch((err) => console.error(err));

